
import Vue from "vue";
import AppCustomTable from "@/components/common/CustomTable.vue";
import { SaleService } from "@/services/sale-service";
import { PurchaseService } from "@/services/purchase-service";
import { BookYearService } from "@/services/book-year-service";
import { HumanFilter } from "@/utils/human-filter";
import { getEmptyIQueryParams, IQueryParams } from "@/utils/query-params";
import { printHumanFloat, printLocalDate, printSaleStatus } from "@/utils/pretty-print";

const LIMIT = 5;

export default Vue.extend({
	data(){
		return {
			loading: false,
			documents: [] as any[],
			loadedForId: 0
		};
	},
	props: {
		item: {
			type: Object as () => any,
			required: true
		}
	},
	computed: {
		isSupplier():boolean {
			return this.item.GroupID == 2;
		},
		summary():string {
			if (this.loading || this.documents.length == 0) return "";
			let last = this.documents[0];
			return `${last.ComputedFriendlyID} · ${this.printAmount(last)}`;
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		"item.ID": {
			immediate: true,
			handler(){
				this.load();
				this.$emit("summary", this.summary);
			}
		}
	},
	methods: {
		printDate(date:Date):string {
			return printLocalDate(date);
		},
		printAmount(doc:any):string {
			let value = this.isSupplier ? doc.Total : doc.TotalIncVAT;
			return printHumanFloat(value || 0, 2);
		},
		printStatus(doc:any):string {
			if (!doc.Status) return "";
			return printSaleStatus(doc.Status);
		},
		open(doc:any){
			if (this.isSupplier) {
				this.$router.push(`/purchase/info/${doc.ID}`);
			} else {
				this.$router.push(`/sales/info/${doc.ID}`);
			}
		},
		getQueryParams():IQueryParams {
			let params = getEmptyIQueryParams();
			params.limit = LIMIT;
			params.orderBy = "InvoiceDate";
			params.orderDirection = "DESC";
			params.dontSaveViewSettings = true;
			return params;
		},
		async fetchDocuments(id:number):Promise<any[]> {
			let params = this.getQueryParams();
			let bookyear = `${BookYearService.selectedBookYear}`;
			if (this.isSupplier) {
				params.filters = [new HumanFilter({Field: "this.ContactID", Operator: "=", Values: [`${id}`]})];
				return (await PurchaseService.getPurchases(params)).data;
			}
			return (await SaleService.getSalesByContactID(id, params, bookyear)).data;
		},
		async load(){
			let id = this.item.ID;
			if (!id || this.loadedForId == id) return;
			this.loadedForId = id;
			this.loading = true;
			this.documents = [];
			try {
				let documents = await this.fetchDocuments(id);
				if (this.item.ID != id) return;
				this.documents = documents;
			} catch (err) {
				this.documents = [];
			} finally {
				this.loading = false;
			}
		}
	},
	components: {
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
